import { CampaignPlace } from '../../typings/campaignPlace';

export const SAVE_CAMPAIGN_PLACE_EDITOR = 'SAVE_CAMPAIGN_PLACE_EDITOR';
export type SAVE_CAMPAIGN_PLACE_EDITOR = typeof SAVE_CAMPAIGN_PLACE_EDITOR;

export interface SaveCampaignPlaceEditor {
    type: SAVE_CAMPAIGN_PLACE_EDITOR;
    campaignId: string;
    place: CampaignPlace;
}

export function saveCampaignPlaceEditorAction(campaignId: string, place: CampaignPlace): SaveCampaignPlaceEditor {
    return {
        type: SAVE_CAMPAIGN_PLACE_EDITOR,
        campaignId,
        place
    };
}
